import styled from "styled-components/macro";
import { GlobalStyles } from "../../GlobalStyles.styles";

export const SettingsBack = styled.div`
  color: #edebeb;
  position: absolute;
  top: 10%;
  left: 0;
  cursor: pointer;
`;

export const SettingsBackground = styled.div`
  background: var(--clr-settingsbg);
  width: 100%;
  height: 159px;
`;

export const DeviceSettings = styled.div`
  margin-top: 1.5em;
  text-align: center;
  border-top-right-radius: 100%;
`;

// Device Mode
export const TelemetryButton = styled.button`
  padding: 1em 1.5em;
  border: #414340;

  background: gray;

  color: #edebeb;
  border-top-left-radius: 7px;
  border-bottom-left-radius: 7px;

  &:focus {
    background-color: #1f729f;
  }
`;

export const MonitorButton = styled.button`
  padding: 1em 1.5em;
  border: #414340;
  background: gray;
  color: #edebeb;
  border-top-right-radius: 7px;
  border-bottom-right-radius: 7px;

  &:focus {
    background-color: #1f729f;
  }
`;

// MainSetup
export const MainSetupSettings = styled.div`
  overflow-y: scroll;
  min-width: 100%;
  height: 100%;
  background: var(--clr-settingsbg);

  ::-webkit-scrollbar {
    width: 8px; /* Width of the scrollbar */
  }

  ::-webkit-scrollbar-track {
    background-color: inherit; /* Color of the track */
  }

  ::-webkit-scrollbar-thumb {
    background-color: lightgray;
    border-radius: 5px; /* Rounded corners of the thumb */
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #555; /* Color of the thumb on hover */
  }

  ::-webkit-scrollbar-thumb:active {
    background-color: #000; /* Color of the thumb when active */
  }

  :last-child {
    border: none;
  }
`;
export const MainSetupItem = styled.div`
  border-bottom: 1px solid #f6f6f635;
  color: ${({ gray }) => (gray ? "var(--clr-settingsfontgray)" : "#edebeb")};
  background: ${({ active }) => (active ? "gray" : "none")};
  /* color: {{(gray) => gray ? "pink" : #edebeb}} ; */
  padding: 0.75em;
  cursor: pointer;

  &:hover {
    background-color: gray;
  }
`;

export const MainSetupItemSmall = styled.div``;

// pause alarms
export const PauseAlarmsAlert = styled.div`
  color: #edebeb;
  margin-top: 0.5em;
  padding: 0.25em;
  background-color: #6d6868;
  text-align: center;
  margin-left: 0.5em;
  padding-left: 0.5rem;
`;

// op modes
export const SaveButton = styled(TelemetryButton)`
  position: absolute;
  top: 17%;
  right: 5%;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  background-color: #1f729f;
  padding: 0.5em 1.5em;
`;

// standby

export const SkBackground = styled.div`
  /* margin-top: -8px; */
  /* height: 215px; */
  /* background: #414340; */
  margin: 0;
`;

export const StandbyMessage = styled.div`
  margin: 0;
  padding: 0 0.3em;
`;

export const StandbyWrapFlexContainer = styled.div`
  border-top: 1px solid white;
  border-bottom: 1px solid white;

  padding: 0.75em 0;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;

export const StandbyWrapFlex = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5em;
`;
export const StandByButtonCancel = styled(TelemetryButton)`
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  background-color: #8f9395;
  padding: 0.5em 1.5em;
  display: inline;

  &:focus {
    background-color: #1f729f;
  }
`;
export const StandByButtonConfirm = styled(TelemetryButton)`
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  background-color: #1f729f;
  padding: 0.5em 1.5em;
  display: inline;

  &:focus {
    background-color: #1f729f;
  }
`;

export const ButtonWrapper = styled.div`
  padding-right: 1em;
  display: flex;
  justify-content: flex-end;

  margin-top: 1em;
  gap: 0.5em;
`;

//ECG

export const EcgHeading = styled.div`
  display: flex;
  justify-content: center;
  font-size: 1.5rem;
  gap: 1em;
  margin-left: -1em;
  /* margin: 1em; */
  padding-top: 1em;
`;

export const EcgTitle = styled.div``;

export const EcgText = styled.div`
  margin-left: 1em;
  margin-right: 1em;
`;
